import _ from 'lodash'

const MAX_STATUS_FOR_PAY_NOW = 115; // Store Accepted
export const allowPayNow = (order) => {
    return _.get(order, 'total_due', 0) > 0 && _.get(order, 'allow_paynow', 0) === 1 && _.get(order, 'delivery_status') < MAX_STATUS_FOR_PAY_NOW
}

export const isAccepted = (order) => {
    return _.get(order, 'delivery_status', 280) >= 115
}